import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, List, BooleanField, TextField, TextInput, BooleanInput, ReferenceField, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
var OMIT_FIELDS = ["id", "type", "is_public"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Description", source: "description" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(BooleanInput, { label: "Is Public", source: "is_public" }, 3),
    _jsx(TextInput, { source: "election_event_id" }, 4),
    _jsx(TextInput, { source: "contest_id" }, 5),
];
export var ListCandidate = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id", "contest_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: "Candidates" }), _jsx(List, { actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: tenantId || undefined,
                }, filters: Filters, aside: aside, children: _jsxs(DatagridConfigurable, { rowClick: rowClickHandler, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name" }), _jsx(TextField, { source: "description" }), _jsx(TextField, { source: "type" }), _jsx(BooleanField, { source: "is_public" }), _jsx(ReferenceField, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(TextField, { source: "name" }) }), _jsx(ReferenceField, { source: "contest_id", reference: "sequent_backend_contest", children: _jsx(TextField, { source: "name" }) })] }) })] }));
};
